import EventEmitter from 'amkit3-modules/utils/stateful-events'
import fallbackImgSrc from 'amkit3-modules/utils/fallback-img-src'
import { getLogger } from 'amkit3-modules/utils/log4js'
import yaApi from 'amkit3-modules/utils/huya/ya-api'
import themeFactory from './themes/factory'
import HuyaUIEvent from './huya-ui-event'

const logger = getLogger('v/ui/huya/ended-recommend')

class EndedRecommendPanel extends EventEmitter {
  constructor($, $container, options) {
    super()

    this.$ = $
    this.$container = $container
    this._options = options
    this._style = themeFactory.getStyle()
    this._selector = themeFactory.getSelector()
    this._resizeCb = this.resize.bind(this)

    this.$panel = this.$container.find(this._selector.endedRecommend)
    this.$panel.on('click', this._selector.endedRecommendLiveInfoReplayBtn, () =>
      this.emit(HuyaUIEvent.ENDED_RECOMMEND_REPLAY_BTN_CLICK),
    )
    this.$panel.on('click', this._selector.endedRecommendLiveInfoCommentBtn, () =>
      this.emit(HuyaUIEvent.ENDED_RECOMMEND_COMMENT_BTN_CLICK),
    )
    this.$panel.on('click', this._selector.endedRecommendLiveInfoMainSubscribeBtn, () =>
      this.emit(HuyaUIEvent.ENDED_RECOMMEND_SUBSCRIBE_BTN_CLICK),
    )
  }
  show(data) {
    logger.info('recommend show', data)

    if (data && data.relateVideoList && Array.isArray(data.relateVideoList)) {
      data.relateVideoList.forEach((item, index) => {
        item.index = index + 1
      })
    }
    let tpl = themeFactory.getEndedRecommendTpl()
    this.$panel.html(
      tpl({
        style: this._style,
        data,
        huya_video_base: process.env.TEST ? 'test-www.huya.com/video' : 'www.huya.com/video',
      }),
    )

    fallbackImgSrc(
      this.$panel.find(this._selector.endedRecommendLiveInfoAvatar).find('img'),
      '//v-cms-img.huya.com/huya/1212pic_v1.png',
    )
    fallbackImgSrc(
      this.$panel.find(this._selector.endedRecommendVideoListItemCover).find('img'),
      '//vhuya-static.huya.com/amkit/p/duya/common/img/default_live.jpg',
    )
    const json = data.relateVideoList.map((item, key) => {
      return {
        tab_name: '完播视频',
        vid: String(item.vid),
        index: String(key + 1),
        palyvid: window.vid || '',
      }
    })
    yaApi.yaReport({
      eid: 'pageview/position',
      eid_desc: '位置曝光',
      curpage: '虎牙视频站',
      prop: JSON.stringify({
        content_list: JSON.stringify(json),
      }),
    })

    this.$panel.on('click', this._selector.endedRecommendVideoListItem, e => {
      console.log('report', {
        eid: 'click/position',
        eid_desc: '位置点击',
        curpage: '虎牙视频站',
        prop: JSON.stringify({
          tab_name: '完播视频',
          vid: this.$(e.currentTarget).data('vid'),
          index: this.$(e.currentTarget).data('index'),
          palyvid: window.vid,
        }),
      })
      yaApi.yaReport({
        eid: 'click/position',
        eid_desc: '位置点击',
        curpage: '虎牙视频站',
        prop: JSON.stringify({
          tab_name: '完播视频',
          vid: this.$(e.currentTarget).data('vid'),
          index: this.$(e.currentTarget).data('index'),
          palyvid: window.vid,
        }),
      })
    })
    this.$(window).on('resize', this._resizeCb)
    this.resize()

    // TODO
    global.vhuyaplayer_setUnsubscribe = () => this.setUnsubscribe()
    global.vhuyaplayer_setSubscribed = () => this.setSubscribed()
  }
  hide() {
    logger.info('recommend hide')
    this.$(window).off('resize', this._resizeCb)
  }
  resize() {
    let h = this.$container.height()

    if (h > 448) {
      this.showItems(6)
    } else {
      this.showItems(3)
    }
  }
  showItems(count) {
    this.$panel.find(this._selector.endedRecommendVideoListItem).each((index, item) => {
      if (index < count) {
        this.$(item).show()
      } else {
        this.$(item).hide()
      }
    })
  }
  setUnsubscribe() {
    this.$panel
      .find(this._selector.endedRecommendLiveInfoMainSubscribeBtn)
      .addClass(this._style.unsubscribe)
      .removeClass(this._style.subscribed)
      .find('span')
      .text('订阅')
  }
  setSubscribed() {
    this.$panel
      .find(this._selector.endedRecommendLiveInfoMainSubscribeBtn)
      .addClass(this._style.subscribed)
      .removeClass(this._style.unsubscribe)
      .find('span')
      .text('已订阅')
  }
}

export default EndedRecommendPanel
